import React, { memo } from 'react';

import cn from 'classnames';
import Lottie from 'lottie-react';

import ActionMenu from './ActionMenu';

import { getTruncatedName } from '@src/utils';
import { createElementColor } from '@src/helpers';

import HandRaise from '@src/assets/animations/HandRaise.json';

import { TEmojiId } from '@src/types';
import { IActionMenuProps } from '../videoBox.types';

import styles from '../videoBox.module.scss';

interface BoxFooterProps {
  isHandRaised: boolean;
  handRaiseOrder: number | null;
  peerName: string;
  peerColor: number | null;
  isCurrentUser: boolean;
  showName: boolean;
  isPictureInPictureActive: boolean;
  animations: Record<string, any>;
  peerEmoji?: TEmojiId;
  actionMenuProps: IActionMenuProps;
}

const BoxFooter: React.FC<BoxFooterProps> = ({
  isHandRaised,
  handRaiseOrder,
  peerName,
  peerColor,
  isCurrentUser,
  showName,
  isPictureInPictureActive,
  actionMenuProps,
}) => (
  <div className={styles.boxFooter}>
    <div className={styles.userInfo}>
      {isHandRaised ? (
        <div
          className={styles.videoEmojiOrderContainer}
          style={{ ...(peerColor && { backgroundColor: createElementColor(peerColor, 'hand-raise-badge') }) }}
        >
          <span className={styles.raiseHandOrder}>{handRaiseOrder}</span>
          <Lottie
            animationData={HandRaise}
            loop={false}
            style={{ width: 26, height: 26 }}
            rendererSettings={{ className: 'lottie-white' }}
          />
          {showName && (
            <span className={styles.raiseHandName} title={peerName}>
              {getTruncatedName(peerName)}
              {isCurrentUser ? ' (Me)' : ''}
            </span>
          )}
        </div>
      ) : (
        showName && (
          <p
            className={cn(styles.username, {
              'pip-label': isPictureInPictureActive && isCurrentUser,
            })}
            title={peerName}
          >
            {peerName}
            {isCurrentUser ? ' (Me)' : ''}
          </p>
        )
      )}
    </div>
    <ActionMenu {...actionMenuProps} />
  </div>
);

export default memo(BoxFooter);
